// AUTOGENERATED BY 'featureflags/ff.js' DO NOT UPDATE THIS FILE DIRECTLY.
// INSTEAD, UPDATE 'featureflags/features.yaml' AND RUN 'node featureflags/ff.js gen'

/**
 * All active Elation feature flags
 */
enum Feature {
  /** Automatic claim submission based on agentic billing outcomes. ONLY FOR AIO CUSTOMERS. */
  ABAutoSubmit = "ABAutoSubmit",
  /** Automatic claim submission (to the billing queue) based on agentic billing outcomes. This actually moves the claim whereas ABAutoSubmit just scrubs and stores data (shadow deploy). ONLY FOR AIO CUSTOMERS. */
  ABAutoSubmitAction = "ABAutoSubmitAction",
  /** Non-AIO customer coding automation. NOT FOR AGENTIC BILLING CUSTOMERS. */
  AICodingAutomation = "AICodingAutomation",
  /** Non-AIO customer self-enablement for coding automation. NOT FOR AGENTIC BILLING CUSTOMERS. */
  AICodingSelfEnab = "AICodingSelfEnab",
  /** If enabled, note transcription AI will create draft prescription orders for you based on the transcript provided. */
  AIDraftOrderCreate = "AIDraftOrderCreate",
  /** Enables visit note sign off via API (and other documents soon) */
  APIDocumentSigning = "APIDocumentSigning",
  /** Return non-blocking events via APIv2. When OFF, non-blocking events are filtered out. When ON, all events are returned. */
  APIv2NonBlkEvents = "APIv2NonBlkEvents",
  /** Enable the User APIv2 endpoint for applications associated with this practice */
  APIv2UserEndpoint = "APIv2UserEndpoint",
  /** Show annual wellness visit dashboard in the population page */
  AWVDashboard = "AWVDashboard",
  /** Enables access to the Medicare Annual Wellness Visit form template */
  AWVFormTemplate = "AWVFormTemplate",
  /** Enables admin-level users to export a CSV of the records shown in the user activity log */
  ActivityLogExport = "ActivityLogExport",
  /** Hide specific practice settings for non-admin users */
  AdminManagedSettings = "AdminManagedSettings",
  /** Agentic billing self-enablement */
  AgenticBillSelfEnab = "AgenticBillSelfEnab",
  /** Agentic billing visualization tools */
  AgenticBillVizTools = "AgenticBillVizTools",
  /** Adds support for saving insurance updates even if carrier, plan, group ID and Member ID are blank */
  AllowEmptyPatientIns = "AllowEmptyPatientIns",
  /** Show the Pt's PCP in the Clincial Profile even for solo practices */
  AlwaysShowPCPInCP = "AlwaysShowPCPInCP",
  /** Adds validation to prevent appointments from being created with 'No location specified' as the location */
  ApptMustHaveLocation = "ApptMustHaveLocation",
  /** Turn on to show additional visible flag for appointment slots, exposed for XO practices only */
  ApptSlotVisibleFlag = "ApptSlotVisibleFlag",
  /** Enables appointment time changes audit functionality from Snowflake audit logs */
  ApptTimeChangesAudit = "ApptTimeChangesAudit",
  /** Using FHIR API to schedule appointments with locations */
  ApptsOnFhir = "ApptsOnFhir",
  /** Determines whether a practice should use the Athena CCDA post processors */
  AthenaCcdaImports = "AthenaCcdaImports",
  /** Determines the Athena CCDA post processor imports lab results */
  AthenaCcdaResults = "AthenaCcdaResults",
  /** Auto-Import Billing */
  AutoImportBilling = "AutoImportBilling",
  /** Enables enhanced provider availability associated with the SchedulingTimeZone flag (availability by appointment type and location) to be visible on the Booking Site; also supports filtering by location and appointment type on the booking site. */
  AvailabilityOnBkSite = "AvailabilityOnBkSite",
  /** For supported entity types, use the experimental message batching */
  BatchWebsocketMsgs = "BatchWebsocketMsgs",
  /** Bidirectional labs */
  BiDiLabs = "BiDiLabs",
  /** Show outstanding orders in outstanding items section of patient chart, must have BidiLabs feature flag on. */
  BidiLabsOutItems = "BidiLabsOutItems",
  /** (Beta) Enables selection and sync of non-billable ICD codes for assessments and billing */
  BillDxAllowInvalid = "BillDxAllowInvalid",
  /** Enable practice settings for billing DX import coding automation configuration */
  BillDxImportConfig = "BillDxImportConfig",
  /** Enables the new billing DX Navigator UI for IMO/ICD/Problem search. */
  BillDxNavigator = "BillDxNavigator",
  /** Enables the Elation RCM Customer coding feedback side panel on Bill 2.0 */
  BillRulesElation = "BillRulesElation",
  /** Enables the NCCI coding feedback side panel on Bill 2.0 */
  BillRulesNCCI = "BillRulesNCCI",
  /** Enables the new Billing Home page. */
  BillingHomeEnabled = "BillingHomeEnabled",
  /** Enables the billing metrics page */
  BillingMetrics = "BillingMetrics",
  /** Allows patients to book appointments with an email or a phone number if enabled. If not enabled, only email will be used to match; if no match is found, a new chart will be created. */
  BookViaEmailOrPhone = "BookViaEmailOrPhone",
  /** Allow practice admins to choose which sections to show in CCDA import dialog */
  CCDAPreferences = "CCDAPreferences",
  /** DO NOT USE. Internal flag to enable features for CEHRT 2022 requirements. */
  CEHRT2022 = "CEHRT2022",
  /** Use server-side (chart-assist-api) persisted conversation history for Clinical Insights patient search and report chat. */
  CIChatHistoryFromDB = "CIChatHistoryFromDB",
  /** Enable CI web search capabilities */
  CIWebSearch = "CIWebSearch",
  /** New CQMs (some derived from Health Maint) to meet CPC+ requirements */
  CQMsForCPCPlus = "CQMsForCPCPlus",
  /** Enables caching of the draft notes queue */
  CachedDraftNotes = "CachedDraftNotes",
  /** Enables the Care Dashboard dialog to surface per-problem interventions, goals, and related data (beta) */
  CareDashboard = "CareDashboard",
  /** Use the new CareGaps V2 service */
  CareGapsV2 = "CareGapsV2",
  /** Enable ability to grant and revoke chart access from user account profiles */
  ChartAccessEditable = "ChartAccessEditable",
  /** Enables Clinical Insights / Chart Assist surface for AI-powered search in the patient chart. */
  ChartAssist = "ChartAssist",
  /** Enables POST fallback for /items/ endpoint when query string exceeds safe URL length */
  ChartItemsPostFetch = "ChartItemsPostFetch",
  /** Routes ClaimMD API calls to the claimmd-mock service. Enabled by practice-populator for demo-populated practices. */
  ClaimMDMock = "ClaimMDMock",
  /** Enables the Claims Home page showing in-flight claim status and projected revenue */
  ClaimsHome = "ClaimsHome",
  /** Enables support for co-signing visit notes. */
  CoSignature = "CoSignature",
  /** Enables access to the collectly patient payments page via an iframe */
  CollectlyIframe = "CollectlyIframe",
  /** (In Development - Do Not Enable) Enables the confidential records list dialog in the patient chart */
  ConfidentialList = "ConfidentialList",
  /** Tie users together and allow switching between practices using dropdown */
  ContextSwitcher = "ContextSwitcher",
  /** Copy forward the last bill (claim for AIO) as a draft for user to modify and submit */
  CopyLastBill = "CopyLastBill",
  /** Surfaces a link to the customer-facing case portal where customers can view and manage their support cases */
  CustomerCasePortal = "CustomerCasePortal",
  /** Enables Debug Level logging with datadog browser logging. Should be enabled by user and disabled after debug information is obtained. */
  DebugDDLogging = "DebugDDLogging",
  /** Default the checkbox off for the aggressive-chopped-fax stuff */
  DefaultFaxAttach = "DefaultFaxAttach",
  /** Flag for allowing practice staff to send delegate referrals via Direct Message */
  DelegateReferralDMs = "DelegateReferralDMs",
  /** Disable automated creation of visit notes from appointments */
  DisableCalendarVNA = "DisableCalendarVNA",
  /** Provide a way to add and edit doctags for letters. */
  DocTagsForLetters = "DocTagsForLetters",
  /** Enables Non-admin Staff only being able to delete Documents which they themselves have created AND have not yet been signed-off */
  DocumentDeletionAuth = "DocumentDeletionAuth",
  /** Enables practice settings for splitting IMO concepts that contain multiple ICD codes */
  DxSplitConfig = "DxSplitConfig",
  /** Enables an EB demo link button in the navbar for non-EB practices to drive EB signup and engagement */
  EBDemoLink = "EBDemoLink",
  /** Validates that lab tests belong to the vendor compendium when placing electronic orders. Filters non-compendium tests on reorder and rejects them on backend submission. */
  EOrderCompendiumChk = "EOrderCompendiumChk",
  /** eRx */
  ERx = "ERx",
  /** Enables a signature question to be added to patient forms. */
  ESignatureOnPtForms = "ESignatureOnPtForms",
  /** Determines whether a practice should use the ECW CCDA post processors */
  EcwCcdaImports = "EcwCcdaImports",
  /** Placeholder - Gate for AI Features */
  ElationAI = "ElationAI",
  /** Enables the new Elation AI dialog behavior independently from the broader Elation AI new UX. */
  ElationAIDialog = "ElationAIDialog",
  /** Enables the new Elation AI panel UX with docked/floating modes and global nav pill entry point */
  ElationAINewUX = "ElationAINewUX",
  /** Enables the Elation Analyst in-app chat UI for Cortex Agent */
  ElationAnalyst = "ElationAnalyst",
  /** Enables integration with Elation Billing */
  ElationBilling = "ElationBilling",
  /** Enables integration with Elation Billing canonical insurance list */
  ElationBillingIns = "ElationBillingIns",
  /** Enables the ability to view the Elation Billing dashboard and settings */
  ElationBillingNav = "ElationBillingNav",
  /** Enables integration with Elation Billing canonical payments */
  ElationBillingPay = "ElationBillingPay",
  /** Permission to login via the Elation Go mobile app. */
  ElationGo = "ElationGo",
  /** Practice Level Feature Flag for enabling Provider Zoom Integration */
  ElationZoom = "ElationZoom",
  /** Enables customers currently using Elation Zoom to opt-out before December 2024 if they don't want to be charged for the functionality */
  ElationZoomOptOut = "ElationZoomOptOut",
  /** Email Import */
  EmailImport = "EmailImport",
  /** Propagate patient demographic changes to other practices in the enterprise */
  EntDemogPropagation = "EntDemogPropagation",
  /** Limit enterprise search results to those patients whose employer is in the practice */
  EntSearchByEmployer = "EntSearchByEmployer",
  /** Routes Document confidentiality reads/writes through the new EntityCategorization system in parallel with legacy */
  EntityCategorize = "EntityCategorize",
  /** Enables advanced telemetry */
  ExtTelemetry = "ExtTelemetry",
  /** Enables automatic retry of failed outbound faxes with per-error-code delay schedules. */
  FaxAutoRetry = "FaxAutoRetry",
  /** Allows the practice to use the new Fax Delegate option in the fax inbox so they can delegate sign-off of documents to another user directly from the fax inbox */
  FaxDelegateModal = "FaxDelegateModal",
  /** Use cached value to return fax inbox count. */
  FaxInboxCountCache = "FaxInboxCountCache",
  /** Adds Review button to fax inbox item headers for full page view */
  FaxInboxFastPath = "FaxInboxFastPath",
  /** Dynamically loads fax inbox based on selected fax line. */
  FaxInboxLimitLoading = "FaxInboxLimitLoading",
  /** Shows the Fax Outbox page for practice staff to view outbound fax status and history. */
  FaxOutbox = "FaxOutbox",
  /** Ability to search fax inbox by sender number and name */
  FaxSearchBySender = "FaxSearchBySender",
  /** Enables the Fini AI chat widget for customer support, accessible via the Contact Elation Support button in the I Need Help dropdown. Takes priority over AssembledChatWidget when both are enabled. */
  FiniChatWidget = "FiniChatWidget",
  /** Enables the feature to create patient forms from a PDF or image upload. */
  FormsQuickStart = "FormsQuickStart",
  /** Single flag for all new FO and Kareo enhancements */
  FrontOfficeNewKareo = "FrontOfficeNewKareo",
  /** Enables a UI reskin of the existing SleepOrder as a multipurpose order. */
  GenericOrder = "GenericOrder",
  /** Flag for whether appointment list should include appointemtns from all CDUs */
  GlobalApptList = "GlobalApptList",
  /** Flag for whether the context switcher should display notification from all CDUs */
  GlobalNotifications = "GlobalNotifications",
  /** Flag for whether patient search should return patients from all CDUs */
  GlobalPatientSearch = "GlobalPatientSearch",
  /** Two way sync with Google Calendar */
  GoogleCalendarSync = "GoogleCalendarSync",
  /** Increases the limit of fax pages that can be sent in a single fax */
  HigherFaxPagesLimit = "HigherFaxPagesLimit",
  /** Uses the IMO core API without the DX Navigator UI (premium feature) */
  IMOCoreNoDxNav = "IMOCoreNoDxNav",
  /** A checkbox in the chart filer to extract history from IMS RTFs */
  IMSHistoryImport = "IMSHistoryImport",
  /** Indiana controlled substance print form */
  INControlledPrint = "INControlledPrint",
  /** Immunization HL7 (CEHRT) */
  ImmunizationHl7 = "ImmunizationHl7",
  /** Determines whether a practice should use the CCDA smoking status import feature */
  ImportCcdaSmoking = "ImportCcdaSmoking",
  /** Determines whether a practice should use the CCDA vitals import feature */
  ImportCcdaVitals = "ImportCcdaVitals",
  /** Prevents the display of in-app communications for things like product updates and marketing */
  InAppCommsOptOut = "InAppCommsOptOut",
  /** Displays an in-app onboarding experience to providers who have not completed identity proofing and credential verification */
  InAppProviderOnboard = "InAppProviderOnboard",
  /** Show in app reports */
  InAppReports = "InAppReports",
  /** Enables coding automations when injections are recorded */
  InjCodingAutomation = "InjCodingAutomation",
  /** Enables the injection coding section in practice settings */
  InjCodingSettings = "InjCodingSettings",
  /** Allows users to discontinue documented injections */
  InjectionDiscontinue = "InjectionDiscontinue",
  /** Allows users to view a new form to document new and historical injections */
  InjectionsForm = "InjectionsForm",
  /** Adds support for a 'patient insurance card photo upload' question in patient forms */
  InsCardUploadPtForms = "InsCardUploadPtForms",
  /** Enables a practice to use ClaimMD as the RTE vendor. This flag has no effect if InsEligibilityCheck is not turned on. */
  InsEligClaimMD = "InsEligClaimMD",
  /** Insurance Eligibility Payer ID Field */
  InsEligPayerID = "InsEligPayerID",
  /** Determines whether insurance eligibility payer ID field in Insurance Settings is read only. Note: the Eligibility Payer ID field is only visible if InsEligPayerID is enabled. */
  InsEligPayerIDRdOnly = "InsEligPayerIDRdOnly",
  /** (In development) Enables real-time eligibility checking for patient insurances */
  InsEligibilityCheck = "InsEligibilityCheck",
  /** (DO NOT ENABLE) Temporarily allows writes to the insurances field on the API v2 patient endpoint. When OFF, insurances are read-only. Please ask FOPE before enabling. */
  InsTempWrites = "InsTempWrites",
  /** Enables OCR for insurance card images submitted in patient forms */
  InsuranceCardOcr = "InsuranceCardOcr",
  /** Allow for versioned patient insurances and to support the insurance domain migration to insurance-api */
  InsuranceVersioning = "InsuranceVersioning",
  /** (In development) Enables insurance policyholder relationship validations in the demographics dialog */
  InsuredValidations = "InsuredValidations",
  /** Enables an integrated partner transcription capability. Their chrome plug-in will only work if this is enabled. */
  IntegratedScribe = "IntegratedScribe",
  /** Enables the synching of Guarantor to and from Kareo. */
  KareoGuarantorSync = "KareoGuarantorSync",
  /** Disable strict XML parsing and try to recover on error when parsing Kareo SOAP */
  KareoXMLParseRecover = "KareoXMLParseRecover",
  /** Keep messages to self as 'Requiring action' */
  KeepReqActOnSelfMsgs = "KeepReqActOnSelfMsgs",
  /** Enables the coding automation section in the lab vendor details view */
  LabCodingAutomation = "LabCodingAutomation",
  /** Enables lab orders coding automation settings ("Lab Test Management" section) */
  LabCodingSettings = "LabCodingSettings",
  /** Populate most recent pharmacy in the Rx Form if chart does not have preferred pharmacy saved. */
  LastPharmacyPref = "LastPharmacyPref",
  /** Defer the chart-load bulk fetch of practice users; fetch users on demand or lazily on first list access instead. */
  LazyPracticeUsers = "LazyPracticeUsers",
  /** Reduces the fuzzy-matching of medication history download */
  LessFuzzyMedHx = "LessFuzzyMedHx",
  /** Bypass the practice home unread letters cache, always query DB directly. */
  LetterCacheBypass = "LetterCacheBypass",
  /** Secure Mail Feature enabled */
  Letters = "Letters",
  /** Display a summary of a practices purchased and used licenses on Manage User settings page */
  LicenseSummary = "LicenseSummary",
  /** Store and retrieve vaccine preferences at the service location level instead of practice level. */
  LocationVaccinePrefs = "LocationVaccinePrefs",
  /** Electronic ordering of controlled substances via MDToolbox */
  MDToolboxEPCS = "MDToolboxEPCS",
  /** Improves error handling for the MDToolbox EPCS flow */
  MDToolboxErrors = "MDToolboxErrors",
  /** Gates the split payments button on the patient membership page. Requires MultiPaymentMethod. */
  MMSplitPayment = "MMSplitPayment",
  /** MU Reports */
  MUReports = "MUReports",
  /** Enabling an option for saving med order templates */
  MedOrderTemplates = "MedOrderTemplates",
  /** Display medication reconciliation using card-based UI */
  MedRecCardUI = "MedRecCardUI",
  /** Allow providers to merge medication threads from the medication reconciliation dialog */
  MedRecMerge = "MedRecMerge",
  /** Meds History Download */
  MedsHxDownload = "MedsHxDownload",
  /** Meds Hx Sign & Ignore Option */
  MedsHxIgnore = "MedsHxIgnore",
  /** Enables self-enrollment functionality for practice memberships */
  MembershipSelfEnroll = "MembershipSelfEnroll",
  /** Enables insurance company merge option from practice settings. This intends to reduce duplicated companies. */
  MergeInsCompany = "MergeInsCompany",
  /** Messaging to Groups Only */
  MessageGroupsOnly = "MessageGroupsOnly",
  /** Put most recent contacts at the top of the provider search autocomplete */
  MostRecentContacts = "MostRecentContacts",
  /** Default to no selected interface in the Doc Vax form when there are multiple live submission IR interfaces */
  MultiIRDefault = "MultiIRDefault",
  /** Enable patients to store and manage multiple payment methods with automatic selection of the most recent method by default */
  MultiPaymentMethod = "MultiPaymentMethod",
  /** Flag for supporting multi-state identifiers primarily for ePrescribing. DO NOT ENABLE WITHOUT ORDERS TEAM PERMISSION. */
  MultiStateERX = "MultiStateERX",
  /** Enables the latest Billing Home Improvements, such as compact view and column customization */
  NewBillingHome = "NewBillingHome",
  /** New coding automations - BMI Diagnosis Code Ordering, Export Dx Code (Blood Pressure, PHQ-9), Pain Scale, Functional Status Assessment, W Diagnosis Code Ordering */
  NewCodingAutomation = "NewCodingAutomation",
  /** Enables the new reactified demographics dialog built out in 2021. */
  NewDemographics = "NewDemographics",
  /** Enables the new and improved office messages experience. */
  NewOfficeMessages = "NewOfficeMessages",
  /** When ON, use the new QRDA 3 export in the UI. When OFF, show the old export function/UI. */
  NewQRDA3Export = "NewQRDA3Export",
  /** (Beta) Enables the new clinical form collection (questionnaire) summary format for display in Clinical Profile and exports to visit note */
  NewQuestionSummary = "NewQuestionSummary",
  /** Enabling creation of appointment slots in new scheduler */
  NewSchedulerApptSlot = "NewSchedulerApptSlot",
  /** Toggles CancelRx, RxChange, and RxFill functionality for Surescripts (pending certification) */
  NewSurescripts = "NewSurescripts",
  /** Uses 2FA only for MDToolbox EPCS Integration. Assumes MDToolboxEPCS, NewSurescripts, and SCRIPTv2017071 are turned on */
  NewSurescriptsEPCS = "NewSurescriptsEPCS",
  /** Default passport threads closed */
  NoPatientResponses = "NoPatientResponses",
  /** Do not share historical visit summaries with patient in passport */
  NoShareVisitSumm = "NoShareVisitSumm",
  /** Suppresses inclusion of failed bills/notes from the Urgent practice home queue */
  NoUrgentFailedBill = "NoUrgentFailedBill",
  /** No timer in visit note */
  NoVisitNoteTimer = "NoVisitNoteTimer",
  /** Allows practices to enable non-blocking events in the scheduler */
  NonBlockingEvents = "NonBlockingEvents",
  /** Allows applying visit note templates to non-visit notes (phone notes, calls) as plain text */
  NonVisitTemplates = "NonVisitTemplates",
  /** Allow third parties, such as patients or other providers, to request amendments to a signed visit note */
  Note2AmendmentReq = "Note2AmendmentReq",
  /** Enables Elation visit summaries in Patient Passport */
  Note2InPassport = "Note2InPassport",
  /** Note Assist product (Native AI Scribe) */
  NoteAssist = "NoteAssist",
  /** Allows a staff to use note assist, still requires them to have the NA flag. Requires special approval. */
  NoteAssistAllowStaff = "NoteAssistAllowStaff",
  /** Allows the user to configure custom instructions for Note Assist. */
  NoteAssistCustInstr = "NoteAssistCustInstr",
  /** Allows Note Assist to predict Dx codes for the note (in Assessment & Plan) */
  NoteAssistDx = "NoteAssistDx",
  /** Enables a toolbar in VN1 and VN2 that allows users to scribe from the note, and removes the floating action button for scribing. */
  NoteAssistInNote = "NoteAssistInNote",
  /** Enables AI-powered functionality for generating notes across multiple patients */
  NoteAssistMultiPt = "NoteAssistMultiPt",
  /** Enables OCR and LLM summarization of Reports for Clinical Insights */
  OcrIndexing = "OcrIndexing",
  /** Make insurance read-only for Kareo users */
  OneWayKareoInsur = "OneWayKareoInsur",
  /** Enables PMS vendors to create and update patient outstanding balance */
  OutstandingBalance = "OutstandingBalance",
  /** Access to PLR-specific searches and the compare profile dialog */
  PLR = "PLR",
  /** Access to PLR features for non-enterprise practices */
  PLR4Everyone = "PLR4Everyone",
  /** In patient chart, automatically show shared PLR documents upon load */
  PLRAutoShowSharedDoc = "PLRAutoShowSharedDoc",
  /** Ability to Sign & Import All for PLR */
  PLRMassImport = "PLRMassImport",
  /** Practices can check a PMP registry regarding patient prescriptions */
  PMPCheck = "PMPCheck",
  /** Enables the PREVENT Calculator feature in Clinical Insights / Chart Assist */
  PREVENTCalc = "PREVENTCalc",
  /** Enables the PREVENT Calculator dialog as a standalone in-app EHR tool in the patient chart */
  PREVENTCalcDialog = "PREVENTCalcDialog",
  /** Hide practice contact-info in patient passport (for multi-site practices) */
  PassportHideContact = "PassportHideContact",
  /** Use the date of service for Staff Procedure Notes created via specimen collection for the time of collection rather than today. */
  PastSpecimenCollDate = "PastSpecimenCollDate",
  /** Allows a Patient to Cancel an Appointment */
  PatientCanCancel = "PatientCanCancel",
  /** Enables the use of Patient Cohort functionality */
  PatientCohort = "PatientCohort",
  /** Enables the new patient form builder interface for creating and editing patient forms */
  PatientFormBuilder = "PatientFormBuilder",
  /** Enable State Filtering in patient list */
  PatientListByState = "PatientListByState",
  /** Enables the provider-facing Patient Passport user interface within the practice's Elation instance. This setting does not affect patient access to Patient Passport. */
  PatientPortal = "PatientPortal",
  /** Enables setting the active/inactive/deceased status of a patient */
  PatientStatus = "PatientStatus",
  /** Enables payment-posting to make real Thor autopost calls. When disabled (default), runs in shadow mode — all DB rows are written but no Thor writes occur. */
  PaymentPosting = "PaymentPosting",
  /** Display of payment site url on patient invoices */
  PaymentSiteInvoice = "PaymentSiteInvoice",
  /** Allows access to the pediatric dose calculator in the prescription form */
  PedDoseCalculator = "PedDoseCalculator",
  /** Allows practice admins to view an audit log of changes to the permissions applied to a Physician or Staff user. */
  PermissionsAuditLog = "PermissionsAuditLog",
  /** (In development - Do Not Enable) Enables user to select a viewing time zone on the practice home calendar */
  PracticeCalendarTZ = "PracticeCalendarTZ",
  /** Allows the practice to access Membership Functionality */
  PracticeMemberships = "PracticeMemberships",
  /** Practice level feature flag for enabling Stripe Integration */
  PracticeStripeInt = "PracticeStripeInt",
  /** Certain fields auto-filled from latest PatientImmunization. Tracked at the med or vaccine level. */
  PracticeVaccinePrefs = "PracticeVaccinePrefs",
  /** Prenatal Flowsheets */
  PrenatalFlowsheets = "PrenatalFlowsheets",
  /** Display verification status in 'Edit Patient Problem' dialog */
  ProblemVerification = "ProblemVerification",
  /** Providers network UI */
  ProvidersNetwork = "ProvidersNetwork",
  /** Enabling sorting by patient or provider activities in patient chart */
  PtChartChronoSort = "PtChartChronoSort",
  /** Enables the Report Preview dialog to access AI OCR summarization in the patient chart */
  PtChartReportPreview = "PtChartReportPreview",
  /** Access to coded chart data API for custom quality reporting. */
  QualityReportingAPI = "QualityReportingAPI",
  /** Allows providers and staff to quickly reschedule appointments directly from the appointment popover */
  QuickReschedule = "QuickReschedule",
  /** Enables Quick Views dropdown in Patient List filter pane for AWV eligibility filtering */
  QuickViews = "QuickViews",
  /** Whether or not the practice is RCM enabled or not. */
  RCMEnabledPractice = "RCMEnabledPractice",
  /** Enables the reactified Add/Edit Patient Allergy Dialog */
  ReactAllergiesDialog = "ReactAllergiesDialog",
  /** Enables the reactified Patient Chart page Chronological Record search input */
  ReactChartSearch = "ReactChartSearch",
  /** Enables the new Reactified Draft Letters Tab for the Requiring Actions onthe Practice Home Page.For development only. Do not enable. */
  ReactDraftLetterFeed = "ReactDraftLetterFeed",
  /** Enables the new Reactified Draft Orders Tab for the Requiring Actions on the Practice Home Page. For development only. Do not enable. */
  ReactDraftOrderFeed = "ReactDraftOrderFeed",
  /** Enables the new reactified MVP Letter Dialog for the Practice Home Page. For development only. Do not enable. */
  ReactLetterDialog = "ReactLetterDialog",
  /** Enables the new reactified Patient Passport Messages page in practice settings. For development only. Do not enable. */
  ReactPtPassportMsgs = "ReactPtPassportMsgs",
  /** Enables the reactified prescription renewal dialog */
  ReactRenewal = "ReactRenewal",
  /** Enables the new Reactified Tab Container for the Requiring Actions on the Practice Home Page. */
  ReactReqActContainer = "ReactReqActContainer",
  /** Enables the new Reactified vaccine form */
  ReactVaccineForm = "ReactVaccineForm",
  /** Enables read-only user access control with automatic redirection to read-only app */
  ReadOnlyUsers = "ReadOnlyUsers",
  /** Adds a new Recurly link in the Manage User Accounts page */
  RecurlyLink = "RecurlyLink",
  /** Enabling creation of recurring appointments. */
  RecurringAppts = "RecurringAppts",
  /** Remove default imaging vendors from practices */
  RemoveDefaultImaging = "RemoveDefaultImaging",
  /** Report Notes at Bottom */
  ReportNotesAtBottom = "ReportNotesAtBottom",
  /** Allow providers to delegate reports to staff and groups. Must go with FaxDelegateModal. This will be a practice setting eventually. */
  ReportQueueDelegate = "ReportQueueDelegate",
  /** Enables the LLM summary of OCR'd reports and the multi-turn chat in the RHS of the report preview dialog. */
  ReportSummary = "ReportSummary",
  /** Cache patient form request requiring-action query results */
  ReqActFormCache = "ReqActFormCache",
  /** When enabled this disables the option to select All Physicians when running the appointment report. Users will need to select a specific physician when running the report */
  ReqPhyscnOnApptRprt = "ReqPhyscnOnApptRprt",
  /** Allows users to view and restore deleted faxes in a fax inbox. */
  RestoreDeletedFaxes = "RestoreDeletedFaxes",
  /** Allows practices to view and restore recently deleted patients, including undoing chart merges. */
  RestoreDeletedPts = "RestoreDeletedPts",
  /** Use the Ribbon database instead of the CMS database copy for EPN. */
  RibbonEpn = "RibbonEpn",
  /** Allows the practice to enable or disable the RxInform feature that provides SMS notifications for patients' medication orders */
  RxInform = "RxInform",
  /** Use the new SCRIPT standard when handling eRx */
  SCRIPTv2017071 = "SCRIPTv2017071",
  /** Practice home queue routing optimized for enterprise learnings */
  ScaledQueueRouting = "ScaledQueueRouting",
  /** Enables time zone to be configured on the booking site */
  SchedulingTimeZone = "SchedulingTimeZone",
  /** Default to service location from last bill from the same physician */
  ServLocFromLastBill = "ServLocFromLastBill",
  /** Run payment-posting in a shadow mode where all claims and charges are evaluated but not posted to Thor */
  ShadowPaymentPosting = "ShadowPaymentPosting",
  /** Flag to support creating staff-group to practice delegates. Note that enabling this flag triggers an asynchronous process that can take up to an hour to complete. Please check back later to confirm the flag is enabled. */
  StaffGroupDelegates = "StaffGroupDelegates",
  /** Flag for supporting smarter picking of state when determining the controlled substance schedule of a medication */
  StateEPCS = "StateEPCS",
  /** Enables the Stitch integration for the practice. For development only. Do not enable. */
  Stitch = "Stitch",
  /** Extends DocumentDeletionAuth to providers and blocks patient chart deletion for non-admins. Non-admin providers and non-admin staff may only delete their own unsigned documents. */
  StrictDeletionAuth = "StrictDeletionAuth",
  /** Enable Stripe ACH payments for patient payment collection */
  StripeAchPayments = "StripeAchPayments",
  /** Enables access to the structured demographics form template */
  StructuredDemogForm = "StructuredDemogForm",
  /** Enables LLM-powered structured data extraction from clinical PDFs into native chart entities via APIv2 */
  StructuredExtraction = "StructuredExtraction",
  /** For Elation Billing customers, syncs Billing Alerts from EB in the New Appointment (Create an Event) dialog. One-way sync only. */
  SyncBillingAlerts = "SyncBillingAlerts",
  /** Replaces office message system with task management system */
  TaskManagement = "TaskManagement",
  /** Test feature for integration tests purposes */
  TestFeature = "TestFeature",
  /** Adds an Userpilot Resource Center link to the Need Help menu */
  UPResourceCenterLink = "UPResourceCenterLink",
  /** Enables USCDI v3 compliant C-CDA generation instead of legacy Blue Button implementation */
  USCDIv3CCDA = "USCDIv3CCDA",
  /** Dev bypass — enables enhanced USCDI v3 import without requiring a bulk import ID */
  USCDIv3CCDAImports = "USCDIv3CCDAImports",
  /** Enables enhanced USCDI v3 import behaviors (visit notes, lab reports, new sections) */
  USCDIv3Enhanced = "USCDIv3Enhanced",
  /** (In Development DO NOT ENABLE) Unified patient experience application. */
  UnifiedPatEx = "UnifiedPatEx",
  /** Use an external CQM calculator such as FIGmd */
  UseExternalCQMCalc = "UseExternalCQMCalc",
  /** Give colleagues a discounted invitation */
  UserReferral = "UserReferral",
  /** Push surveys to users on practice home after-hours */
  UserSurveys = "UserSurveys",
  /** VIP Access Control */
  VIPAccessControl = "VIPAccessControl",
  /** Enables the A&P2 context menu functionality for A&P1 ordered lists */
  VN2AP1ContextMenu = "VN2AP1ContextMenu",
  /** Enables backporting to VN1 with better bullet structure */
  VN2CompleteBackport = "VN2CompleteBackport",
  /** Enables generating backported VN1 in bullets (prod data/usage exists) */
  VN2ComplexBackport = "VN2ComplexBackport",
  /** Allows the ability for users to select an edit or view only mode for VN2 draft notes */
  VN2DraftViewMode = "VN2DraftViewMode",
  /** Enables the new version of the Assessment/Plan block in Elation Note, with easy DX/problem search */
  VN2NewAssessPlan = "VN2NewAssessPlan",
  /** Limits blast radius for enforcing user id existence on signatures */
  ValidateSignatureId = "ValidateSignatureId",
  /** Enables coding automations when vaccines are recorded */
  VaxCodingAutomation = "VaxCodingAutomation",
  /** Enables the vaccine coding section in practice settings */
  VaxCodingSettings = "VaxCodingSettings",
  /** Enables elation custom prosemirror plugins to help prevent data loss and retain document structure and data integrity */
  VisitNote2AdvEditor = "VisitNote2AdvEditor",
  /** Enables the Note Prep dialog for Note 2.0. */
  VisitNote2NotePrep = "VisitNote2NotePrep",
  /** Enables Wordsmith first-time user experience */
  WordsmithFtue = "WordsmithFtue",
  /** Adds workspace feature to the practice, including workspace-aware filtering for rooms, appointment types, CPT codes, and Rx templates, as well as requiring actions queue filtering */
  Workspaces = "Workspaces",
  /** POC: Flag for supporting practices being able to access external patient data via Zus tools */
  ZusOutsideCare = "ZusOutsideCare"
};

export default Feature;
